<template>
    <div class="">
        <div class="info">
            <div class="panel-tag">
                {{ __t('user_pwa_LOGO') }}
            </div>
        </div>
        <div class="params mt-5">
            <div class="form-group">
                <label class="form-label">
                    {{ __t("PWA_LOGO") }}
                </label>
                <fileload :doc_id="this.client_id" doc_type="pwa_logo"></fileload>
            </div>
        </div>
    </div>
</template>

<script>
    import Fileload from "../../../../../sys/file_loader/fileload"
    export default {
        name: "pwa_logo",
        props : {
            client_id : {
                type : Number,
                default : 0
            }
        },
        components : {
            Fileload
        },

        computed : {

        }
    }
</script>

<style scoped>

</style>
